import React from 'react';
import { primaryColorSelector } from '../../store/selectors/globalConfigSelectors';
import { useSelector } from 'react-redux';
import { Button as RPLButton } from '@hid-galaxy-ui/galaxy-react';

const Button = (props) => {
  const { onClick, disabled, label, type, icon, variant = 'primary' } = props;

  const { primaryColor } = useSelector((state: any) => ({
    primaryColor: primaryColorSelector(state),
  }));
  const themeStyles = {
    background: primaryColor,
  };

  return (
    <RPLButton
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      label={label}
      style={themeStyles}
      type={type}
      icon={icon}
    />
  );
};

export default Button;
